import { surveyShareStore } from "../stores";

export const useSurveyShareStore = () => surveyShareStore;
